import type { RouteLocationNormalizedLoadedGeneric } from '#vue-router';

import Parser from './parser';
import Serializer from './serializer';

export function parseFilterParams(route: RouteLocationNormalizedLoadedGeneric) {
  const parser = new Parser(route);
  return parser.getVars();
}

export function serializeFilterParams(vars: FilterQuery) {
  const serializer = new Serializer(vars);
  return serializer.getRoute();
}
